import { TableCells, InvestorSpaceModel } from 'models';

export const investorSpaceTableCells: TableCells<InvestorSpaceModel>[] = [
  {
    id: 'uds_cooperativeid',
    label: '#portal.investor.space.cooperative',
    type: 'string',
    small: true,
    xs: true,
  },
  {
    id: 'uds_accessaddress',
    label: '#portal.investor.space.address',
    type: 'string',
    small: true,
    xs: true,
  },
  {
    id: 'uds_spaceaddresscity',
    label: '#portal.investor.space.postalarea',
    type: 'string',
    small: true,
    xs: true,
  },
  {
    id: 'uds_name',
    label: '#portal.investor.space.name',
    type: 'string',
    small: true,
    xs: true,
  },
  {
    id: 'uds_spacetypecode',
    label: '#portal.investor.space.spacetype',
    type: 'string',
    small: true,
    xs: true,
  },
  {
    id: 'uds_squaremeters',
    label: '#portal.investor.space.size',
    type: 'string',
    small: true,
    xs: true,
  },
  {
    id: 'uds_spacestatuscode',
    label: '#portal.investor.space.status',
    type: 'string',
    small: true,
    xs: true,
  },
  {
    id: 'Tenants',
    label: 'Vuokraajat',
    type: 'string',
    canSort: false,
  },
  {
    id: 'TenantRentContractStartDate',
    label: 'Alkaen',
    type: 'string',
    canSort: false,
    style: { textAlign: 'right' },
  },
  {
    id: 'TenantRentContractEndDate',
    label: 'Päättyen',
    type: 'string',
    canSort: false,
    style: {
      textAlign: 'right',
    },
  },
];
